import React from 'react';
import Typography from '~/shared/components/Typography/Typography';
import { Anchor } from '~/shared/components/Anchor';
import VouchersCard, { VouchersCardProps } from '~/shared/components/VouchersCard/VouchersCard';
import { useTranslation } from '~/shared/utils/translation';
import styles from './VouchersList.module.scss';

export interface VouchersListProps {
    vouchers: Omit<VouchersCardProps, 'className'>[];
    title?: string;
    helpText?: string;
    helpUrl?: string;
    onRedeem?: (id: string) => void;
    className?: string;
    isLoading?: boolean;
    hasError?: boolean;
}

const VouchersList: React.FC<VouchersListProps> = ({
    vouchers,
    title = 'DINE VOUCHERS',
    helpText = 'Hvordan indløser jeg mine vouchers?',
    helpUrl = '#',
    onRedeem,
    className,
    isLoading,
    hasError,
}) => {
    const { translate } = useTranslation();

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <Typography variant="title-XS" as="h2">
                {isLoading
                    ? translate('loyalty.loadingVouchers')
                    : hasError
                      ? translate('loyalty.errorLoadingVouchers')
                      : title}
            </Typography>

            <div className={styles.grid}>
                {vouchers.map((voucher) => (
                    <div key={voucher.id} className={styles.cardWrapper}>
                        <VouchersCard {...voucher} onRedeem={onRedeem || voucher.onRedeem} />
                    </div>
                ))}
            </div>

            {helpText && (
                <div className={styles.helpSection}>
                    <Anchor
                        href={helpUrl}
                        className={styles.helpLink}
                        target="_blank"
                        variant="textLink-M"
                    >
                        {helpText}
                    </Anchor>
                </div>
            )}
        </div>
    );
};

export default VouchersList;
